import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";
import { withRouter } from "react-router-dom";
// import { TrainingProposalsContext } from "repository/stores/dashboard/training/training-proposals-provider";

// Actions
// import { deleteProposal } from "repository/actions/data/dashboard/proposals";

export default withSnackbar(
  withRouter(function (props) {
    const { isOpen, setClose, itemId, user, deleteProposal} = props;
    // const {proposals, setProposals, deleteProposal} = React.useContext(TrainingProposalsContext);
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteItem = () => {
      if (user && user != null) {
        setSaveLoading(true);

        deleteProposal( itemId, user.idToken)
          .then((result) => {
            setClose();
            setSaveLoading(false);
            toast.success(`Proposal successfully deleted`);
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete selected proposal"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteItem()}
        actionButtonTitle="Yes, I'm sure"
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to delete this proposal?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
